import { render, staticRenderFns } from "./ManageHeader.vue?vue&type=template&id=53d45eff&scoped=true"
import script from "./ManageHeader.vue?vue&type=script&lang=ts"
export * from "./ManageHeader.vue?vue&type=script&lang=ts"
import style0 from "./ManageHeader.vue?vue&type=style&index=0&id=53d45eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d45eff",
  null
  
)

export default component.exports